import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MasterDataHttpService extends HttpService {
  getCurrencyList(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }
}
